import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Preview } from './components/Preview';

const isPreviewMode = process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('preview');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {isPreviewMode ? <Preview /> : <App />}
  </React.StrictMode>
);
